import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 15000,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// ── Response interceptor ───────────────────────────────────────────────────────
api.interceptors.response.use(
  // Success — unwrap .data
  // Normalize responses for both `res.data` and direct payload usage.
  (response) => {
    const body = response.data;

    if (body && typeof body === "object" && !Array.isArray(body)) {
      return {
        ...body,
        data: Object.prototype.hasOwnProperty.call(body, "data")
          ? body.data
          : body,
      };
    }

    return { data: body };
  },

  // Error — clean up message and handle 401

  // Error — clean up message and handle 401
  (error) => {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong. Please try again.";

    // 401 = token expired or invalid → force re-login by reloading the page.
    // Do NOT force redirect if the user is on a public route or calling a public API.
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname || "";
      const isPublicPath =
        currentPath.startsWith("/staff/") ||
        currentPath.startsWith("/leave-apply") ||
        currentPath.startsWith("/public/") ||
        currentPath === "/login" ||
        currentPath === "/";

      const requestUrl = error.config?.url || "";
      const isPublicEndpoint =
        requestUrl.includes("/public/") ||
        requestUrl.includes("/auth/login");

      if (!isPublicPath && !isPublicEndpoint) {
        // Small delay so any in-flight toast can be shown first
        setTimeout(() => window.location.replace("/login"), 100);
      }
    }

    const normalizedError = new Error(message);
    normalizedError.response = error.response;
    normalizedError.status = error.response?.status;

    return Promise.reject(normalizedError);
  },
);

export default api;
